import * as React from "react";
import {FileWithPreview} from "react-dropzone";
import {connect} from "react-redux";
import {Action, Dispatch} from "redux";
import {Field, formValueSelector, InjectedFormProps, reduxForm,} from "redux-form";
import {ConstColor} from "src/config/styles_const/styles_const";
import Assets from "src/presentation/assets/img/assets";
import styled from "styled-components";
import {frontEndConfig} from "../../../../../config/config";
import {customerConfig, prefectureConfig,} from "../../../../../config/language/ja-JP/domain/model_text";
import {Customer, Gender} from "../../../../../domain/model/customer";
import {createDayArray, createMonthArray, createYearsArray,} from "../../../../../util/commonFuntion";
import {createAddressOptionDom, createOptions,} from "../../../../../util/select_option_function";
import * as Validator from "../../../../../util/validation";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import BtnLinkCancelSmall from "../../../../common/atom/btn/btn_link_cancel_small";
import StyledAvatarDropZone from "../../../../common/atom/drop_zone/styled_avatar_drop_zone";
import ErrorText from "../../../../common/atom/text/error_text";
import DatepickerWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/datepicker_wrapper";
import MonthDaysWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/month_days_wrapper";
import YearWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/year_wrapper";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import CancelButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/cancel_button_wrapper";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";
import FormGroupMultiSelectConnectRf from "../../../../common/molecular/form_group/form_group_multi_select_connect_rf";
import FormGroupSelectConnectRf from "../../../../common/molecular/form_group/form_group_select_connect_rf";
import FormGroupTextareaConnectRf from "../../../../common/molecular/form_group/form_group_textarea_connect_rf";
import {AppState} from "../../../../store/app_state";

const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

const validate = (values: any) => {
    const errors: any = {};

    return errors;
};

interface IStateProps {
    initialValues:
        | {
        customer: Customer | null;
        iconURLFileObject?: File;
    }
        | undefined;
    formValues: any;
}

interface IProps extends IStateProps {
    onGeneratePR: () => void;
    generatedPR: string | undefined;
}

interface IState {
    imageError: string | null;
    showHelp: boolean;
}

class CustomerMypageMainCustomerForm extends React.Component<
    IProps & InjectedFormProps<{}, IProps>,
    IState
> {
    constructor(props: IProps & InjectedFormProps<{}, IProps>) {
        super(props);

        this.state = {
            imageError: null,
            showHelp: false,
        };
    }

    public componentWillUpdate(nextProps: any, nextState: any): void {
        // 更新実行後の初期化処理
        if (
            this.props.formValues &&
            this.props.initialValues.customer &&
            nextProps.initialValues.customer.gsIconURL !==
            this.props.initialValues.customer.gsIconURL
        ) {
            URL.revokeObjectURL(this.props.formValues.preview);
            this.props.change("iconURLFileObject", null);
        }
    }

    public componentDidUpdate(prevProps: IProps & InjectedFormProps<{}, IProps>) {
        if (this.props.generatedPR) {
            if (prevProps.generatedPR !== this.props.generatedPR) {
                this.props.change("customer.pr", this.props.generatedPR);
            }
        }
    }

    public componentWillUnmount(): void {
        // Make sure to revoke the data uris to avoid memory leaks
        if (this.props.formValues != null) {
            URL.revokeObjectURL(this.props.formValues.preview);
        }
    }

    public render(): JSX.Element {
        const {anyTouched, invalid, handleSubmit, pristine, submitting, change} =
            this.props;

        const customer: Customer | null = this.props.initialValues
            ? this.props.initialValues.customer
            : null;

        if (!customer) {
            return <div/>;
        }

        let res: JSX.Element;

        const iconURL: string = customer.getIconURL();
        const updateIconURL: string | null = this.props.formValues
            ? this.props.formValues.preview
            : null;

        // 編集ページ
        res = (
            <React.Fragment>
                <form name="CustomerMypageMainCustomerForm" onSubmit={handleSubmit}>
                    <StyledAvatarDropZone
                        name="CustomerMypageMainCustomerForm-dropzone"
                        handleOnDrop={this.handleOnDrop}
                        updateIconURL={updateIconURL}
                        iconURL={iconURL}
                    />

                    <FormFieldWrapper>
                        <Field
                            label="アカウント名"
                            placeholder="リベラ"
                            name="customer.name"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.customerName, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="名前（ふりがな）"
                            placeholder="りべらたろう"
                            name="customer.nameKana"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.customerNameKana, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <DatepickerWrapper>
                            <YearWrapper>
                                <Field
                                    label="生年月日：年"
                                    name={`customer.birthdate.year`}
                                    component={FormGroupSelectConnectRf}
                                    type="text"
                                    validate={[Validator.required]}
                                    require={true}
                                >
                                    {createAddressOptionDom(createYearsArray(100))}
                                </Field>
                            </YearWrapper>
                            <MonthDaysWrapper>
                                <Field
                                    label="生年月日：月"
                                    name={`customer.birthdate.month`}
                                    component={FormGroupSelectConnectRf}
                                    type="text"
                                    validate={[Validator.required]}
                                    require={true}
                                >
                                    {createAddressOptionDom(createMonthArray())}
                                </Field>
                            </MonthDaysWrapper>
                            <MonthDaysWrapper>
                                <Field
                                    label="生年月日：日"
                                    name={`customer.birthdate.day`}
                                    component={FormGroupSelectConnectRf}
                                    type="text"
                                    validate={[Validator.required]}
                                    require={true}
                                >
                                    {createAddressOptionDom(createDayArray())}
                                </Field>
                            </MonthDaysWrapper>
                        </DatepickerWrapper>
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <Field
                            label={customerConfig.gender}
                            name="customer.gender"
                            component={FormGroupSelectConnectRf}
                            type="text"
                        >
                            <option disabled={true}/>
                            <option value={Gender.Gender_Male} key={Gender.Gender_Male}>
                                {customerConfig.genderList.get(Gender.Gender_Male)}
                            </option>
                            <option value={Gender.Gender_Female} key={Gender.Gender_Female}>
                                {customerConfig.genderList.get(Gender.Gender_Female)}
                            </option>
                            <option value={Gender.Gender_Unknown} key={Gender.Gender_Unknown}>
                                {customerConfig.genderList.get(Gender.Gender_Unknown)}
                            </option>
                        </Field>
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label={customerConfig.phoneNumber}
                            placeholder="入力してください"
                            name="customer.phoneNumber"
                            component={FormGroupInputConnectRf}
                            type="tell"
                            validate={[Validator.phoneNumber, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper id="pr">
                        <OpenAILink>
                            <OpenAILinkText
                                onClick={() => {
                                    this.props.onGeneratePR();
                                }}
                            >
                                生成AIで自己PRの下書きを行う
                            </OpenAILinkText>
                            <OpenAILinkIconContainer>
                                <OpenAILinkIcon
                                    src={Assets.help}
                                    onClick={() => {
                                        this.setState({showHelp: true});
                                    }}
                                />
                                <OpenAITooltip>
                                    生成AIを用いて、あなたの職歴情報から自己PRの下書きを作成する機能です。
                                    <br/>
                                    この機能を使用するには、最低2件以上の職歴情報を保存しておく必要があります。
                                    <br/>
                                    下書きを行うボタンを押すと、ポップアップが表示され、下書きが作成されます。
                                    <br/>
                                    その情報を必要に応じて書き換えて保存することができます。
                                </OpenAITooltip>
                            </OpenAILinkIconContainer>
                        </OpenAILink>
                        <Field
                            label={customerConfig.pr}
                            placeholder={`取締役COOとして、全社の経営戦略の策定、法人向けSaaS事業(トップ人材特化型DBサービス)の事業戦略、新規事業を担当。主にマーケティング・営業・広報・開発部門を統括し、4年間で売上3億円→100億円、社員数10名→150名まで牽引。入社2年後にマザーズ上場、その1年後に東証一部上場を実現。`}
                            name="customer.pr"
                            rows={3}
                            component={FormGroupTextareaConnectRf}
                            validate={[Validator.pr]}
                        />
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <Field
                            label={customerConfig.address}
                            name="customer.address"
                            component={FormGroupSelectConnectRf}
                            type="text"
                        >
                            {createAddressOptionDom(prefectureConfig.addressList)}
                        </Field>
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label={customerConfig.requirements}
                            placeholder="入力してください"
                            name="customer.requirements"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.requirements]}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label={customerConfig.languages}
                            name="customer.languages"
                            component={FormGroupMultiSelectConnectRf}
                            type="select-multiple"
                            placeholder="語学"
                            options={createOptions(customerConfig.languageList)}
                            isMulti={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label={customerConfig.academicBackgrounds}
                            placeholder="入力してください"
                            name="customer.academicBackgrounds"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.academicBackgrounds]}
                        />
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <Field
                            label={"ポートフォリオ"}
                            placeholder=""
                            name="customer.portfolio"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[]}
                            require={false}
                        />
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <Field
                            label={"Facebook URL"}
                            placeholder=""
                            name="customer.facebookURL"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[]}
                            require={false}
                        />
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <Field
                            label={"LinkedIn URL"}
                            placeholder=""
                            name="customer.linkedInURL"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[]}
                            require={false}
                        />
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <Field
                            label={"X URL"}
                            placeholder=""
                            name="customer.xURL"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[]}
                            require={false}
                        />
                    </FormFieldWrapper>

                    <FormFieldWrapper>
                        <Field
                            label={"出身地"}
                            name="customer.birthplace"
                            component={FormGroupSelectConnectRf}
                            type="text"
                        >
                            {createAddressOptionDom(prefectureConfig.addressList)}
                        </Field>
                    </FormFieldWrapper>

                    {anyTouched && invalid && (
                        <SubmitErrorTextWrapper>
                            <ErrorText>入力を完了してください</ErrorText>
                        </SubmitErrorTextWrapper>
                    )}

                    <SubmitButtonWrapper>
                        <CancelButtonWrapper>
                            <BtnLinkCancelSmall to="/customer/mypage/customer">
                                キャンセル
                            </BtnLinkCancelSmall>
                        </CancelButtonWrapper>
                        <BtnCorporateLarge
                            name="CustomerMypageMainCustomerForm-submit"
                            type="submit"
                            widthSize="200px"
                            disabled={pristine || submitting || invalid}
                        >
                            保存
                        </BtnCorporateLarge>
                    </SubmitButtonWrapper>
                </form>
            </React.Fragment>
        );

        return res;
    }

    private handleOnDrop = (
        acceptedFiles: FileWithPreview[],
        rejectedFiles: FileWithPreview[]
    ): void => {
        try {
            this.setState({imageError: null});

            if (rejectedFiles.length > 1) {
                throw new Error("複数のファイルが選択されました");
            } else if (
                rejectedFiles.length > 0 &&
                rejectedFiles[0].size > uploadFileMaxSize
            ) {
                throw new Error("ファイルサイズオーバ");
            } else {
                
                this.props.change("iconURLFileObject", acceptedFiles[0]);
            }
        } catch (error) {
            this.setState({imageError: error.message});
        }
    };
}

const selector = formValueSelector("CustomerMypageMainCustomerForm");

const mapStateToProps = (state: AppState, initialProps: any) => {
    return {
        formValues: selector(state, "iconURLFileObject"),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};

export default reduxForm<{}, IProps>({
    form: "CustomerMypageMainCustomerForm",
    validate,
})(
    connect(mapStateToProps, mapDispatchToProps)(CustomerMypageMainCustomerForm)
);

const OpenAILinkText = styled.div`
    color: ${ConstColor.Corporate};
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
`;

const OpenAILinkIcon = styled.img`
    display: block;
    margin-left: 10px;
    cursor: pointer;
`;

const OpenAITooltip = styled.div`
    position: absolute;
    bottom: -80px; // 要素の高さに応じて調整する
    right: 0px;
    background-color: black;
    color: white;
    padding: 5px;
    border-radius: 5px;
    font-size: 10px;
    line-height: 14px;
`;

const OpenAILink = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
`;

const OpenAILinkIconContainer = styled.div`
    & > ${OpenAITooltip} {
        display: none;
    }

    // ホバー時にツールチップを表示する

    &:hover > ${OpenAITooltip} {
        display: block;
    }
`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/edit/customer_mypage_main_customer_form.tsx